

export const createUser = (mobile, token) => {

    localStorage.setItem('info',JSON.stringify({
        cellphone: mobile,
        token: token,
        status: 0,
    }))

}


export const updateUser = (user) => {
    let current_user = getUser();
    localStorage.setItem('info',JSON.stringify({
        cellphone: current_user.cellphone,
        token:current_user.token,
        fname: user.fname,
        lname: user.lname,
        flname: user.flname,
        ncode: user.ncode,
        email: user.email,
        phone: user.phone,
        sex: user.sex,
        address: user.address,
        status: 2
    }))
}

export const getUser = () => {
    if(localStorage.getItem('info')!=null)
    {
        try {
            return JSON.parse(localStorage.getItem('info'));
        }catch (e) {
            return  null;
        }

    }else {
        return  null;
    }

}

export const clearUsers = () => {
    localStorage.clear()

}
